import { Box, Table, TableBody, TableCell, TableRow } from "@mui/material"
import DefaultAlwaysHint from "../hints/AlwaysHints"
import SometimeHint from "../hints/SometimesHint"
import BFAImg from "../../core/assets/oot/gshd/ice-arrows_32x32.png"
import CuccosImg from "../../core/assets/oot/gshd/chicken_32x32.png"
import Scarecrow from "../../core/assets/oot/classic/OoT_Scarecrow_Model.png"
import Token30 from "../../core/assets/oot/gshd/30-gold-skulltula_32x32.png"
import Token40 from "../../core/assets/oot/gshd/40-gold-skulltula_32x32.png"
import Token50 from "../../core/assets/oot/gshd/50-gold-skulltula_32x32.png"
import Nocturne from "../../core/assets/oot/gshd/nocturne_32x32.png"
import OcrarinaOfTime from "../../core/assets/oot/gshd/ocarina-of-time_32x32.png"
import GoronMask from "../../core/assets/oot/gshd/biggoron_32x32.png"
import Frog from "../../core/assets/oot/gshd/frogs_32x32.png"
import SkullMask from "../../core/assets/oot/gshd/skull-mask_32x32.png"
import ReworkItemTracker from "../tracker/ReworkitemTracker"
import ReworkChildSongTracker from "../tracker/ReworkChildSongTracker"
import ReworkWarpSongTracker from "../tracker/ReworkWarpSongTracker"
import RewardRewardTracker, { RewardDto, RewardEnum } from "../tracker/ReworkRewardTracker"
import { useState } from "react"
import { MedallionProps } from "../inventory/medallions/MedallionInterface"
import ImportantHint from "../hints/ImportantHint"
import PreventRefresh from "../../core/components/utils/PreventRefresh"
import ReworkPathTracker from "../tracker/ReworkPathTracker"
import GoModeButton from "../../core/components/GoModeButton"
import LightSphereTracker from "../sphere/LigthSphereTracker"
import { LocationQueryAutocomplete } from "../hints/LocationAutocomplete"
import AdditionalItemTracker from "../tracker/AdditionalItemTracker"

const LeagueTracker = () => {



            let [rewards, setRewards] = useState<Array<RewardDto>>([
   
            ]);
  
            const setReward = (r: RewardEnum, props: MedallionProps) => {
              setRewards([
                ...rewards.filter((x) => x.id !== r),
                { id: r, settings: props },
              ]);
            };
      

    return <Box onContextMenu={(e) => e.preventDefault()}>
      <PreventRefresh />
      <ReworkItemTracker  top={100} left={80} />

      <ReworkChildSongTracker display="horizontal" a cleft cdown cright cup top={310} left={90} />
      <ReworkWarpSongTracker display="horizontal" a cleft cdown cright cup top={350} left={90} />
   
      <RewardRewardTracker left={280} top={100} rewards={rewards} setReward={setReward} />
      
      <Box position={"absolute"} left={200} top={395}>
        <AdditionalItemTracker  adultTradeSequenceOnlyOne={true} gerudoCardShuffle={false} openFountain={false} />
      </Box>
      

    {/* Always */}
    <Box position={"absolute"} top={250} left={280}><DefaultAlwaysHint hint={ { name: "ZR Frogs Ocarina Game", img: Frog}} /></Box>
    <Box position={"absolute"} top={250} left={360}><DefaultAlwaysHint hint={ { name: "DMT Biggoron", img: GoronMask }} /></Box>
    <Box position={"absolute"} top={282} left={280}><DefaultAlwaysHint hint={{ name: "LW Deku Theater Skull Mask",  img: SkullMask }} /></Box>
    <Box position={"absolute"} top={282} left={360}><DefaultAlwaysHint hint={ { name: "Kak 30 Gold Skulltula Reward",  img: Token30 }} /></Box>
    <Box position={"absolute"} top={314} left={280}><DefaultAlwaysHint hint={ { name: "Kak 40 Gold Skulltula Reward",  img: Token40 }} /></Box>
    <Box position={"absolute"} top={314} left={360}><DefaultAlwaysHint hint={ { name: "Kak 50 Gold Skulltula Reward",  img: Token50 }} /></Box>
    <Box position={"absolute"} top={346} left={280}><DefaultAlwaysHint hint={ { name: "Song of Ocarina of Time",  img: OcrarinaOfTime }} /></Box>
    <Box position={"absolute"} top={346} left={360}><DefaultAlwaysHint hint={ { name: "Song Burning Kak",  img: Nocturne }} /></Box>


    {/* 5 Woth  */}
    <ReworkPathTracker left={80} top={430} />
    {/* 3 Importants  */}
    <Box position={"absolute"} top={670} left={80} display={"flex"} alignItems={"center"}> <ImportantHint /></Box>
    <Box position={"absolute"} top={710} left={80} display={"flex"} alignItems={"center"}> <ImportantHint /></Box>
    <Box position={"absolute"} top={750} left={80} display={"flex"} alignItems={"center"}> <ImportantHint /></Box>

    {/* Dual Sometimes */}
    <Box position={"absolute"} top={100} left={450} display={"flex"} alignItems={"center"}><SometimeHint type="dual" /></Box>
    <Box position={"absolute"} top={140} left={450} display={"flex"} alignItems={"center"}><SometimeHint type="dual"  /></Box>

    {/* Sometimes */}
    <Box position={"absolute"} top={220} left={450} display={"flex"} alignItems={"center"}><SometimeHint /></Box>
    <Box position={"absolute"} top={260} left={450} display={"flex"} alignItems={"center"}><SometimeHint /></Box>
    <Box position={"absolute"} top={300} left={450} display={"flex"} alignItems={"center"}><SometimeHint/></Box>
    <Box position={"absolute"} top={340} left={450} display={"flex"} alignItems={"center"}><SometimeHint/></Box>
    <Box position={"absolute"} top={380} left={450} display={"flex"} alignItems={"center"}><SometimeHint/></Box>

    <Box position={"absolute"} top={450} left={530}>
        <GoModeButton />
    </Box>
    <Box position={"absolute"} top={550} left={490}>
          <LocationQueryAutocomplete label="Spawn Adult" sx={{width: "200px"}}/>
          <LocationQueryAutocomplete label="Spawn Child" sx={{width: "200px"}}/>
    </Box>
    <Box position={"absolute"} top={80} left={730}>
            <LightSphereTracker />
    </Box>
    
    {/* Settings */}
    <Box sx={{whiteSpace: "pre-wrap"}} position={"absolute"} top={800} left={80} display={"flex"} flexDirection={"column"} alignItems={"center"}>
      <Box > Settings: &#9;</Box>
      <Table sx={{borderCollapse: "collapse"}}>
        <TableBody>
        <TableRow>

          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}> Age / Spawn : Random </Box></TableCell>

          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}> Songs can't be path</Box></TableCell>
          <TableCell  sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  <img src={BFAImg} alt={"BFA"}/> BFA On </Box></TableCell>
          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  <img src={CuccosImg} alt={"Cuccos"}/> : 3 </Box></TableCell>
          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  Beatable Only </Box></TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  CAMC : On </Box></TableCell>
          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  <img src={Scarecrow} alt={"Scarecrow"} height={32} width={32}/> : Free </Box></TableCell>
          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  Ruto at F1</Box></TableCell>
          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  Bridge : 5 Medallions</Box></TableCell>
          <TableCell sx={{padding: 0, paddingRight: 3}}><Box display={"flex"} alignItems={"center"}>  GBK : 6 Medallions</Box></TableCell>
        </TableRow>
      
        </TableBody>
      </Table>
        
    </Box>
    </Box>
}

export default LeagueTracker